"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var isEqual = require("lodash.isequal");
var PLUGIN_NAME = 'format_clear';
var filterMark = function (marks) { return marks.filter(function (mark) { return !mark.type.spec.notClear; }); };
var FormatClearController = /** @class */ (function (_super) {
    __extends(FormatClearController, _super);
    function FormatClearController() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDisable = false;
        _this.toolbar = {
            className: PLUGIN_NAME,
            tooltip: PLUGIN_NAME,
            handler: function (editor) {
                editor.clearFormat();
            }
        };
        _this.keymap = {
            'Mod-e': function (editor) {
                if (_this.isDisable)
                    return false;
                editor.clearFormat();
                return true;
            }
        };
        _this.disable = function (editor) {
            var _a = editor.view.state, storedMarks = _a.storedMarks, selection = _a.selection;
            var $from = selection.$from;
            // 有storedMarks就不取$from.marks
            if (storedMarks && filterMark(storedMarks).length)
                return false;
            if (!storedMarks && filterMark($from.marks()).length)
                return false;
            var marks = [];
            editor.nodesBetween(function (node) {
                if (marks.length)
                    return false;
                // @ts-ignore
                if (node.inlineContent && !isEqual(node.attrs, node.type.defaultAttrs)) {
                    marks.push(true);
                }
                if (node.isInline && node.marks.length) {
                    marks.push.apply(marks, filterMark(node.marks));
                }
                return undefined;
            });
            _this.isDisable = !marks.length;
            return _this.isDisable;
        };
        return _this;
    }
    return FormatClearController;
}(core_utilities_1.SylController));
exports.FormatClearController = FormatClearController;
var FormatClearPlugin = /** @class */ (function (_super) {
    __extends(FormatClearPlugin, _super);
    function FormatClearPlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = PLUGIN_NAME;
        _this.Controller = FormatClearController;
        return _this;
    }
    return FormatClearPlugin;
}(core_utilities_1.SylPlugin));
exports.FormatClearPlugin = FormatClearPlugin;
//# sourceMappingURL=format-clear.js.map